<template>
	<div
		class="bg"
		:style="`background-image: url('/images/back.webp')`"
	>
		<PageContainer
			spacing="0"
			size="l"
			:class="$isMobile() ? '' : 'pt-10'"
			class="px-4 pb-4"
		>
			<h1
				:class="$isMobile() ? 'text-h6 my-4' : 'text-h3 mt-10'"
				class="text-center"
			>
				{{ $t('views.home.title') }}
			</h1>
			<SimulatorSteps
				:class="$isMobile() ? '' : 'mt-10'"
			/>
		</PageContainer>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { Meta, MetaInfo } from '@/decorators';

	import SimulatorSteps from '@/components/SimulatorSteps';

	@Component({
		components: {
			SimulatorSteps
		}
	})
	export default class Home extends Vue {
		tab = null;

		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: this.$t('views.home.meta.title') as string,
				meta: [
					{
						name: 'description',
						vmid: 'description',
						content: ''
					}
				]
			};
		}
	}
</script>

<style lang="scss" scoped>
.bg {
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	min-height: 100%;
	width: 100%;
	overflow: hidden;
	margin: 0 auto;
}
</style>
